<!--页面代码从这里开始拷贝-->
<template>
  <div>
    <el-skeleton :rows="6" v-if="isLoading" animated />
    <div v-else>
      <el-row>
        <el-col
          ><el-button
            type="primary"
            @click="initNacos"
            style="margin-bottom: 10px"
            >刷新</el-button
          ></el-col
        >
      </el-row>
      <el-row>
        <el-col class="box-card">
          <el-descriptions title="Nacos健康一览" border>
            <el-descriptions-item label="服务总数"
              ><el-tag
                >{{ servces.metrics.serviceCount }}个</el-tag
              ></el-descriptions-item
            >
            <el-descriptions-item label="负载大小"
              ><el-tag>{{ servces.metrics.load }}</el-tag></el-descriptions-item
            >
            <el-descriptions-item label="内存剩余"
              ><el-tag>{{ servces.metrics.mem }}</el-tag></el-descriptions-item
            >
            <el-descriptions-item label="可响应服务个数"
              ><el-tag
                >{{ servces.metrics.responsibleServiceCount }}个</el-tag
              ></el-descriptions-item
            >
            <el-descriptions-item label="实例个数"
              ><el-tag
                >{{ servces.metrics.instanceCount }}个</el-tag
              ></el-descriptions-item
            >
            <el-descriptions-item label="可响应实例个数"
              ><el-tag
                >{{ servces.metrics.responsibleInstanceCount }}个</el-tag
              ></el-descriptions-item
            >
            <el-descriptions-item label="cpu"
              ><el-tag>{{ servces.metrics.cpu }}</el-tag></el-descriptions-item
            >
            <el-descriptions-item label="Nacos状态"
              ><el-tag>{{
                servces.metrics.status
              }}</el-tag></el-descriptions-item
            >
          </el-descriptions>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px">
        <el-col>
          <el-descriptions :title="`服务列表一览(共${servces.count})个`" border>
            <el-descriptions-item
              :label="`${index + 1}.服务名称`"
              v-for="(s, index) in servces.doms"
              :key="s"
            >
              <el-tag
                @click="showInstances(s)"
                title="点击我查看实例详情"
                style="cursor: pointer"
                >{{ s }}</el-tag
              >
            </el-descriptions-item>
          </el-descriptions>
        </el-col>
      </el-row>

      <el-dialog
        :title="`服务[${serviceName}]-实例列表`"
        :visible.sync="dialogTableVisible"
      >
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="健康实例列表" name="first">
            <el-table :data="instances.healthList">
              <el-table-column property="ip" label="ip地址"></el-table-column>
              <el-table-column
                property="port"
                label="服务端口"
              ></el-table-column>
              <el-table-column
                property="weight"
                label="服务权重"
              ></el-table-column>
              <el-table-column
                property="clusterName"
                label="集群名称"
              ></el-table-column>
              <el-table-column
                property="serviceName"
                label="服务名称"
              ></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="不健康实例列表" name="second"
            >
            <el-table :data="instances.unHealthList">
              <el-table-column property="ip" label="ip地址"></el-table-column>
              <el-table-column
                property="port"
                label="服务端口"
              ></el-table-column>
              <el-table-column
                property="weight"
                label="服务权重"
              ></el-table-column>
              <el-table-column
                property="clusterName"
                label="集群名称"
              ></el-table-column>
              <el-table-column
                property="serviceName"
                label="服务名称"
              ></el-table-column>
            </el-table>
            </el-tab-pane
          >
        </el-tabs>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import NacosApi from "@/api/NacosApi";
export default {
  name: "serviceList",
  data() {
    return {
      servces: {},
      isLoading: true,
      instances: {},
      dialogTableVisible: false,
      serviceName: "",
      activeName:"first"
    };
  },
  mounted() {
    this.initNacos();
  },
  methods: {
    initNacos() {
      (this.isLoading = true),
        NacosApi.serverList().then((resp) => {
          this.servces = resp.data;
          this.isLoading = false;
        });
    },
    showInstances(name) {
      this.dialogTableVisible = true;
      this.serviceName = name;
      this.activeName = "first";
      let params = {
        name: name,
      };
      NacosApi.queryInstances(params).then((resp) => {
        this.instances = resp.data;
      });
    },
    handleClick(tab, event) {
        this.activeName = tab.name;
      }
  },
};
</script>
  <!--页面代码从这里结束拷贝-->